<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="10">
        <b-row class="mb-5 top-container align-items-center " align-h="center">
          <b-col sm="8" align-self="center">
            <h1
              id="host"
              class=" pt-3 d-flex col-12 text-truncate"
              @mouseover="onMouseHover($event)"
            >
              <span class="text-truncate">
                {{ page.url }}
              </span>
              <b-tooltip v-if="tooltip" target="host" placement="top">
                {{ page.url }}
              </b-tooltip>
              <a :href="page.url" target="_blank">
                <b-img class="pl-2" src="~/static/images/goto.svg" alt="true" />
              </a>
            </h1>
          </b-col>
          <b-col sm="4">
            <Scorecard id="pagescore" :progress="page.score" />
          </b-col>
        </b-row>
        <div>
          <div v-for="(checklist, index) in page.pages_errors" :key="index">
            <Rule
              :status="checklist.rule_status"
              :code="checklist.code"
              :title="checklist.title"
            />
            <div
              v-for="(error, errindex) in checklist.error_content"
              :key="errindex"
            >
              <div v-if="errindex < 5">
                <div v-if="error">
                  <div v-if="error.url">
                    <h5>{{ error.url }}</h5>
                  </div>
                  <div v-else-if="error.title && error.length">
                    <h5>{{ error.title }}: {{ error.length }} Character</h5>
                  </div>
                  <div v-else-if="error.meta_description && error.length">
                    <h5>
                      {{ error.meta_description }}: {{ error.length }} Character
                    </h5>
                  </div>
                  <div v-else-if="error.response_time">
                    <h5>Response Time: {{ error.response_time }} Second</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Rule from '@/components/Rule.vue'
import Scorecard from '@/components/Scorecard'
export default {
  layout: 'seo',
  components: {
    Rule,
    Scorecard
  },
  async asyncData({ store, params }) {
    await store.dispatch('getPageDetails', { params })
  },
  data() {
    return {
      tooltip: false
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(from.name)
    if (isNaN(to.params.id)) {
      next({ name: 'index' })
    } else {
      next()
    }
  },

  async asyncData({ store, params, redirect }) {
    await store.dispatch('getPageDetails', { params, redirect })
  },
  computed: {
    page() {
      return this.$store.getters.getPageDetails
    }
  },
  methods: {
    onMouseHover(e) {
      if (e.toElement.offsetWidth < e.toElement.scrollWidth) {
        this.tooltip = true
      } else {
        this.tooltip = false
      }
    }
  },
  head() {
    return {
      title: 'WebAuditor'
    }
  }
}
</script>

<style scoped>
.badge {
  float: right;
  margin-right: 8px;
}
.url-truncate {
  width: 99%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>

<style>
body {
  background-color: white;
}
#pagescore {
  height: 195px;
  width: 160px;
  position: relative;
  float: right;
  margin: auto;
}
@media only screen and (min-width: 150px) and (max-width: 780px) {
  #pagescore {
    float: none;
  }
}
</style>
